import type { NavigateFunction } from "react-router-dom";
import { useSession } from "../../../shared/session/useSession.js";

/**
 * Dünne Hülle um `useSession` — die Quickview braucht keinen eigenen
 * Bootstrap, ihre Taktiken kommen über `usePublicPayload()`.
 *
 * Bis Phase 8 war das eine eigene, mit `useEditorBootstrap` fast wortgleiche
 * Umsetzung derselben Sitzungslogik.
 */
export function useQuickviewSession(navigate: NavigateFunction) {
  const { session, sessionRef, adoptSession, checking } = useSession(navigate, {
    redirectTo: "/",
  });
  return { session, sessionRef, adoptSession, checking };
}
